module.exports = __webpack_public_path__ + "static/media/dark-blue.348cfadf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/belts/dark-blue.svg
// module id = 78
// module chunks = 0